module.exports = __webpack_public_path__ + "img/undraw_Choose_re_7d5a.3c61e523.png";